import React from "react";
import { Link } from "react-router-dom";
import "../../styles/Global.css";

interface AuthLinksProps {
  showSignUp?: boolean;
  showResetPassword?: boolean;
  returnTo?: string | null;
}

/**
 * Component for authentication related links (sign up and reset password)
 * Typically displayed at the bottom of authentication forms
 *
 * @param {AuthLinksProps} props - Component properties
 * @returns {JSX.Element} - Rendered auth links component
 */
const AuthLinks: React.FC<AuthLinksProps> = ({
  showSignUp = true,
  showResetPassword = true,
  returnTo = null,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        width: "100%",
        marginTop: "24px",
      }}
    >
      {showSignUp && (
        <div style={{ fontSize: "14px", color: "var(--theme-muted, #4A4A4A)" }}>
          Don't have an account?{" "}
          <Link
            to="/signup"
            state={returnTo ? { from: returnTo } : undefined}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{
              color: "var(--theme-primary-action, var(--tertiary-color))",
              fontWeight: "600",
              textDecoration: "none",
            }}
          >
            Sign Up
          </Link>
        </div>
      )}

      {showResetPassword && (
        <div style={{ fontSize: "14px", color: "var(--theme-muted, #4A4A4A)" }}>
          Forgot your password?{" "}
          <Link
            to="/forgot-password"
            state={returnTo ? { from: returnTo } : undefined}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{
              color: "var(--theme-primary-action, var(--tertiary-color))",
              fontWeight: "600",
              textDecoration: "none",
            }}
          >
            Reset it here
          </Link>
        </div>
      )}
    </div>
  );
};

export default AuthLinks;
